import React from "react";
var __jsx = React.createElement;
import { useMemo } from "react";
import { normalizeCampaigns } from "./normalizeCampaigns";
import CardCampaignLabel from "./CardCampaignLabel";
import PostDetailsCampaignLabel from "./PostDetailsCampaignLabel";
var ROW_CLASSES = {
  card: "grid grid-cols-2 mt-2 mb-3 items-center gap-2",
  postDetails: "grid grid-cols-2 mt-2 items-center gap-4"
};

/** One presentational component per variant — each renders from the same {data, type} contract. */
var VARIANT_LABEL = {
  card: CardCampaignLabel,
  postDetails: PostDetailsCampaignLabel
};

/**
 * Marketing Theme label row, rendered directly under the cash/finance price boxes.
 * SE-12945: https://syarah.atlassian.net/browse/SE-12945
 * Data contract confirmed in SE-12996 comment 89984: reads `campaign_tags` (post/view-online,
 * /index, /similar, /recommended, list-favourite) — at most one "cash" and one "finance" tag,
 * already priority-resolved server-side.
 *
 * Orchestrates data (normalize + pick cash/finance) and hands each active tag to the
 * variant-specific label component (CardCampaignLabel / PostDetailsCampaignLabel). The
 * precheckout variant lives outside this orchestrator (see PrecheckoutCampaignLabel) since
 * its data flow is one campaign per payment method, not a cash/finance pair under one price row.
 */
var MarketingThemeLabels = function MarketingThemeLabels(_ref) {
  var campaigns = _ref.campaigns,
    variant = _ref.variant,
    hasFinanceColumn = _ref.hasFinanceColumn,
    postId = _ref.postId;
  var normalized = useMemo(function () {
    return normalizeCampaigns(campaigns);
  }, [campaigns]);
  var activeCash = useMemo(function () {
    var _normalized$find;
    return (_normalized$find = normalized.find(function (c) {
      return c.type === "cash";
    })) !== null && _normalized$find !== void 0 ? _normalized$find : null;
  }, [normalized]);
  // A finance tag is meaningless on a cash-only car — there's no finance price to sit under.
  var activeFinanceTag = useMemo(function () {
    var _normalized$find2;
    return (_normalized$find2 = normalized.find(function (c) {
      return c.type === "finance";
    })) !== null && _normalized$find2 !== void 0 ? _normalized$find2 : null;
  }, [normalized]);
  var activeFinance = hasFinanceColumn ? activeFinanceTag : null;
  if (!activeCash && !activeFinance) return null;
  var VariantLabel = VARIANT_LABEL[variant];
  return /*#__PURE__*/React.createElement("div", {
    className: ROW_CLASSES[variant],
    id: postId ? "posts-card-marketing-theme-labels-".concat(postId) : undefined
  }, activeCash && /*#__PURE__*/React.createElement("div", {
    className: "min-w-0 col-start-1"
  }, /*#__PURE__*/React.createElement(VariantLabel, {
    data: activeCash,
    type: "cash"
  })), activeFinance && /*#__PURE__*/React.createElement("div", {
    className: "min-w-0 col-start-2"
  }, /*#__PURE__*/React.createElement(VariantLabel, {
    data: activeFinance,
    type: "finance"
  })));
};
export default MarketingThemeLabels;